import React from 'react';
import PropTypes from 'prop-types';
// import ButtonSecondary from './ButtonSecondaryNew';
import ButtonSecondary from '../../elems/ButtonSecondary';
import { FormattedMessage } from 'react-intl';

const PricingCard5 = ({ user, createSubscription, people, users, price, discountPrice, plan, monthly, updatePlan, id, togglePopup, popup }) => {

  const coaching = <FormattedMessage id="admin.pricing.card.coaching" defaultMessage="+ 2 hours coaching per month"/>;
    
  return (
    <div className="w-24 pricing_item text-center bg-white py-3 px-2 br-6 mb-3">
      <p className="fs2_5 bold">
        <FormattedMessage
          id="admin.pricing.card.title5"
          defaultMessage="Pro + Culture"
        />
      </p>

      {monthly ? (
        <p className="fs2 my-1 blue">
          <FormattedMessage
            id="admin.pricing.card.usd"
            defaultMessage="$"
          />{price}{' '}
          <FormattedMessage
            id="admin.pricing.card.price2"
            defaultMessage="user / month"
          />
        </p>
      ) : (
        <p className="fs2 my-1 blue">
          <span className="old-price">
            <FormattedMessage
            id="admin.pricing.card.usd"
            defaultMessage="$"
            />{price}
          </span>{' '}
          <FormattedMessage
            id="admin.pricing.card.usd"
            defaultMessage="$"
          />{discountPrice}{' '}
          <FormattedMessage
            id="admin.pricing.card.price2"
            defaultMessage="user / month"
          />
        </p>
      )}
      <p className="small mb-xs">
        <FormattedMessage
          id="admin.pricing.card.upto"
          defaultMessage="Up to"
        />{' '}
       <b>{users}{' '}
        <FormattedMessage
          id="admin.pricing.card.users"
          defaultMessage="users"
        />
        </b>
      </p>
      <p className="bold small mb-xs">
        <FormattedMessage
          id="admin.pricing.card.pro"
          defaultMessage="Everything in Pro, plus"
        />
      </p>
      <p className="small mb-xs">
        <FormattedMessage
          id="oneOnOne"
          defaultMessage="1:1 Meetings"
        />
      </p>
      <p className="small mb-xs">
        <FormattedMessage
          id="icebreakers"
          defaultMessage="Icebreakers"
        />
      </p>
      <p className="small mb-xs">
        <FormattedMessage
          id="mood.surveys"
          defaultMessage="Mood Surveys"
        />
      </p>
      <p className="small mb-xs">
        <FormattedMessage
          id="kudos"
          defaultMessage="Kudos"
        />
      </p>
      <p className="small mb-xs">
        <FormattedMessage
          id="feedback"
          defaultMessage="Feedback"
        />
      </p>
      <p className="small mb-2 bold pt-xs">{coaching}</p>

      <ButtonSecondary 
        createSubscription={createSubscription} 
        user={user}
        isStripe={true} 
        people={people}
        companyId={id} 
        plan={plan} 
        btn={4}
        togglePopup={togglePopup} 
        popup={popup} 
        updatePlan={updatePlan} 
        monthly={monthly} 
        link={true} externalLink={99} 
        />
    </div>
  );
};

PricingCard5.propTypes = {
  users: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  discountPrice: PropTypes.number.isRequired
};

export default PricingCard5;
